import FormattedMessage from 'I18n/components/FormattedMessage';
import MissingLabel from 'automation-ui-core/components/MissingLabel';
import OwnerName from 'automation-ui-references/customer-data/OwnerName';
import PropertyName from 'automation-ui-references/object-type-properties/PropertyName';
import * as OwnerAssignmentTypes from 'automation-ui-action-features/owner-assignment/OwnerAssignmentTypes';
import * as InternalPropertyDefaults from 'automation-ui-action-features/object-type-properties/InternalPropertyDefaults';
import { jsx as _jsx } from "react/jsx-runtime";
export default function CreateTaskOwnerLabel({
  actionMetadata: {
    ownerAssignment
  },
  flowObjectTypeId
}) {
  const {
    ownerId,
    ownerProperty,
    type
  } = ownerAssignment;
  if (type === OwnerAssignmentTypes.OBJECT_OWNER) {
    return /*#__PURE__*/_jsx(PropertyName, {
      propertyName: InternalPropertyDefaults.HUBSPOT_OWNER,
      objectTypeId: flowObjectTypeId
    });
  }
  if (type === OwnerAssignmentTypes.OBJECT_PROPERTY) {
    return /*#__PURE__*/_jsx(PropertyName, {
      propertyName: ownerProperty,
      objectTypeId: flowObjectTypeId
    });
  }
  if (type === OwnerAssignmentTypes.CUSTOM) {
    return /*#__PURE__*/_jsx("strong", {
      children: /*#__PURE__*/_jsx(OwnerName, {
        id: ownerId
      })
    });
  }
  if (type === OwnerAssignmentTypes.NONE) {
    return /*#__PURE__*/_jsx("strong", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-action-features.action-features.create-task.noOwnerAssignment"
      })
    });
  }
  return /*#__PURE__*/_jsx(MissingLabel, {
    type: "hubspotOwner"
  });
}